import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  .pointerEventsNone {
    pointer-events: none;
  }
`;
